import { AppData, Lightning, Log, Registry } from "@lightningjs/sdk";
import { NavigationManager, Row, TextBox, Tile, TitleRow } from "@lightningjs/ui-components"
import * as styles from "./RowItem.styles"

import { throttle } from 'throttle-debounce';
import { FocusInfo } from "../grid-view-model";
import { REQUEST_STATUS } from "../../../enum";
import { AppSetup } from "../../../app-setup";
import ExpandableTileLandscape from "../ExpandableTile/ExpandableTileLandscape";
import MidCarouselTile from "../ExpandableTile/MidCarouselTile";
import { Helper } from "../../../helper";
import { Logger } from "../../../logger";



/**
 * This class Obj is used as the row element for he maingrid.
 * updated the latest ui-component version and extended the TitleRow Component.
 * @export
 * @class RowItem
 * @typedef {RowItem}
 * @extends {TitleRow<TitleRow.TemplateSpec>}
 */
export default class RowItem extends TitleRow<TitleRow.TemplateSpec> {

    throttleFunc!: Function
    _initialFocus = -1
    isTransition = false;
    disableVideoPreview?: boolean;

    index = 0;
    visibleItems = 8
    bufferItems = 2
    elementToRemove = null
    prevTime = 0

    static get __componentName() {
        return 'RowItem';
    }

    static get __themeStyle() {
        return styles;
    }



    /**
     * _template we defind the dom elements.
     * updated this as we no need to handle the title object as it is extented from TitleRow.
     * @static
     * @returns {*}
     */
    static override _template() {
        return {
            Counter: {
                x: 1600,
                flexItem: { margin: 0 },
                type: TextBox,
                content: '',
                style: {
                    textStyle: {
                        fontFace: Helper.getFontFamily('Black')
                    }
                }
            },
            ...super._template()
        };
    }

    override _init() {
        super._init()
        this._Items.collision = true
        this.alwaysScroll = true
        this.rowStyle = Helper.getRowStyle(this.data.item.rowList)
    }

    static get properties() {
        return [...super.properties, 'title', 'disableVideoPreview'];
    }

    static get tags() {
        return [...super.tags, { name: 'Counter', path: 'Counter' }];
    }

    override _construct() {
        super._construct();
        this._autoResizeHeight = false
    }

    _update() {
        super._update()
        this._updateCounter()
    }

    override _render() {
        super._render()
        this.index = this.selected.itemIndex
        //this._updateCounter()
        //this.onRequestItems()
    }

    _updateCounter() {
        if (this.items.length > 0) {
            this._Counter.patch({
                h: 0,
                content: `${this.selected.itemIndex + 1} | ${this.data.item.rowList.videosCount}`
            });
        }
    }

    async onRequestItems() {
        const { rowList } = this.data.item
        const nextFocusItemIndx = this.items[this.items.length - 1].itemIndex
        const nextPageToFetch = Math.floor(nextFocusItemIndx / rowList.limit)
        if (
            nextPageToFetch <= rowList.totalPages - 1 &&            
            rowList.fetchedPageList[nextPageToFetch] == undefined
        ) {
            await rowList.fetchMoreVideos(nextPageToFetch)
            this.items.map((item, index) => {
                if (item.imgSrc == '') {
                    item.imgSrc = rowList.videos[item.itemIndex].main_picture
                }
            })
            // for (let i = strt; i < ed; i++) {
            //     const item = rowList.videos[i]
            //     const length = this.items.length
            //     // if (i <= length - 1) {
            //     //   this.removeItemAt(i)
            //     // }
            //     // const itemData = {
            //     //   imgSrc: item.main_picture,
            //     // }
            //     //this.items[0]?.imgSrc = item.main_picture
            //     if(this.items[i].imgSrc == '') {
            //         this.items[i].imgSrc = item.main_picture
            //     }
            //     //addItems.push(itemData)
            //     // if (length - 1 < i) {
            //     //   this.appendItemsAt(itemData, i)
            //     // }
            // }
            //this.appendItemsAt(addItems, strt)
        }
    }

    _getItemsToDisplay(selectedIndex): { start: number, end: number } {
        let stIndx = Math.max(selectedIndex - this.bufferItems,0)
        let endIndx = Math.min(stIndx + (this.visibleItems + (this.bufferItems * 2)) - 1, this.data.item.rowList.videosCount - 1)
        return { start: stIndx, end: endIndx }
    }

    /**
     * Get item dimensions and image source based on row type
     * @private
     */
    private _getItemDimensions() {
        const { appConfig } = AppData as AppSetup;
        const isCarouselRow = !this.disableVideoPreview && appConfig?.enableMidCarousel && this.data.item.rowList.row_type === 'carousel'
        const isNonClickRow = appConfig?.enableMidCarousel && this.data.item.rowList.row_type === 'non-click'
        const useCarouselDimensions = isCarouselRow || isNonClickRow
        
        return {
            itemWidth: useCarouselDimensions ? 800 : this.data.item.rowList.row_item_width,
            itemHeight: useCarouselDimensions ? 450 : this.data.item.rowList.row_item_height,
            isCarouselRow,
            isNonClickRow,
            useCarouselDimensions
        }
    }

    /**
     * Get image source based on row type
     * @private
     */
    private _getImageSource(item: any, useCarouselDimensions: boolean): string {
        return useCarouselDimensions
            ? (item && item.bg_image_landscape) ? item.bg_image_landscape : ''
            : (item && item.main_picture) ? item.main_picture : ''
    }

    _createVideoList(vodItems: any[]) {
        this._initialFocus = this.data.focusItem
        const itemsToDisplay = this._getItemsToDisplay(this._initialFocus)
        const items = []
        
        const { itemWidth, itemHeight, isCarouselRow, useCarouselDimensions } = this._getItemDimensions()

        for (let i = itemsToDisplay.start; i <= itemsToDisplay.end; i++) {
            if (i >= 0) {
                let item = vodItems[i]
                
                if (isCarouselRow) {
                    items.push({
                        type: MidCarouselTile,
                        fixed: true,
                        w: itemWidth,
                        h: itemHeight,
                        videoItem: item,
                        imgSrc: this._getImageSource(item, true),
                        blockItem: (item && item.blockItem) ? item.blockItem : '',
                        collision: true,
                        itemIndex: i
                    })
                } else {
                    items.push({
                        type: ExpandableTileLandscape,
                        fixed: true,
                        w: itemWidth + (this.data.item.rowList.isNumberRow ? 180 : 0),
                        h: itemHeight,
                        isNumberRow: this.data.item.rowList.isNumberRow,
                        rowType: this.data.item.rowList.row_type,
                        imgSrc: this._getImageSource(item, useCarouselDimensions),
                        blockItem: (item && item.blockItem) ? item.blockItem : '',
                        collision: true,
                        itemIndex: i
                    })
                }
            }
        }
        this.items = items
        this.selectedIndex = this._initialFocus - itemsToDisplay.start
        this.index = (this.selected ? this.selected.itemIndex : this.selectedIndex)

        // Registry.setTimeout(() => {
        //     this.$vodItemChanged()
        // }, 200)

        Log.info('RowItem: _createVideoList: SelectedIndex', this.selectedIndex, this.data.focusItem, this.mode)
        //this.scrollTo(this.data.focusItem, 0.05)
    }

    $vodItemChanged() {
        if (this._initialFocus >= 0 && this.mode == 'focused') {
            this._updateCounter()
            this.onRequestItems()
            const focusInfo: FocusInfo = {
                focusRow: this.data.rowUIIndex,
                foucsItem: this.selected.itemIndex
            }
            this.fireAncestors('$vodRowChanged', focusInfo)
        }
    }

    /**
     * updateRowItems: This is be called when there is change in row like queue row
     * where it is added or updated to refresh it.
     * it will cleare the row and repopulate it instantly.
     *
     */
    updateRowItems() {
        this._createVideoList(this.data.item.rowList.videos)
        this._updateCounter()
    }

    override _enable() {
        //console.log('RowItem _enable:', this.title, this.data.item)
        if (this.data.item.rowList.fetchedPageList[0] == REQUEST_STATUS.OK) {
            this._createVideoList(this.data.item.rowList.videos)
        } else if(this.data.item.rowList.fetchedPageList[0] == REQUEST_STATUS.FAIL) {
            this.fireAncestors('$rowFailed', { ...this.data.item, rowUIIndex: this.data.rowUIIndex })
        } else {
            this.data.item.rowList.fetchMoreVideos(0)
                .then(() => {
                    //This is to ensure the row is loaded even if it is displayed before the response.
                    // will update the row when is it visible. on the row fetched.
                    this._createVideoList(this.data.item.rowList.videos)
                })
        }
        return
    }

    override set announce(announce) {
        super.announce = announce;
    }


    /**
     * This call back function will be triggered from ColumnContainer
     * when the transition is completed.
     * here we reset the isTransition to false to handle the next key event.
     */
    override transitionDone() {
        this.isTransition = false
    }


    /**
     * This function will append the thumbnail to the ui list.
     * will be called when onRight is triggered.
     * @param {*} selectedIndex
     */
    appendItemsToRight(selectedIndex) {
        const nextItemToAdd = this._getItemsToDisplay(selectedIndex)
        const lastAddedItem = this.items[this.items.length - 1]
        if (lastAddedItem.itemIndex < nextItemToAdd.end) {
            const item = this.data.item.rowList.videos[nextItemToAdd.end]
            const { itemWidth, itemHeight, isCarouselRow, useCarouselDimensions } = this._getItemDimensions()
            
            if (isCarouselRow) {
                this.appendItems([{
                    type: MidCarouselTile,
                    fixed: true,
                    w: itemWidth,
                    h: itemHeight,
                    videoItem: item,
                    imgSrc: this._getImageSource(item, true),
                    blockItem: (item && item.blockItem) ? item.blockItem : '',
                    collision: true,
                    itemIndex: nextItemToAdd.end
                }])
            } else {
                this.appendItems([{
                    type: ExpandableTileLandscape,
                    fixed: true,
                    w: itemWidth + (this.data.item.rowList.isNumberRow ? 180 : 0),
                    h: itemHeight,
                    isNumberRow: this.data.item.rowList.isNumberRow,
                    rowType: this.data.item.rowList.row_type,
                    imgSrc: this._getImageSource(item, useCarouselDimensions),
                    blockItem: (item && item.blockItem) ? item.blockItem : '',
                    collision: true,
                    itemIndex: nextItemToAdd.end
                }])
            }
        }
    }

    /**
     * This function will append the thumbnail to the ui list.
     * will be called when onLeft is triggered.
     * @param {*} selectedIndex
     */
    appendItemsToLeft(selectedIndex) {
        const prevItemToAdd = this._getItemsToDisplay(selectedIndex)
        const firstAddedItem = this.items[0]
        if (firstAddedItem.itemIndex > prevItemToAdd.start) {
            const item = this.data.item.rowList.videos[prevItemToAdd.start]
            const { itemWidth, itemHeight, isCarouselRow, useCarouselDimensions } = this._getItemDimensions()
            
            if (isCarouselRow) {
                this.prependItems([{
                    type: MidCarouselTile,
                    fixed: true,
                    w: itemWidth,
                    h: itemHeight,
                    videoItem: item,
                    imgSrc: this._getImageSource(item, true),
                    blockItem: (item && item.blockItem) ? item.blockItem : '',
                    collision: true,
                    itemIndex: prevItemToAdd.start
                }])
            } else {
                this.prependItems([{
                    type: ExpandableTileLandscape,
                    fixed: true,
                    w: itemWidth + (this.data.item.rowList.isNumberRow ? 180 : 0),
                    h: itemHeight,
                    isNumberRow: this.data.item.rowList.isNumberRow,
                    rowType: this.data.item.rowList.row_type,
                    imgSrc: this._getImageSource(item, useCarouselDimensions),
                    blockItem: (item && item.blockItem) ? item.blockItem : '',
                    collision: true,
                    itemIndex: prevItemToAdd.start
                }])
            }
        }
    }

    canProcessKey() {
        const {appConfig} = AppData as AppSetup
        if(appConfig?.enableGridAnimation) return true

        const curDt = new Date().getTime()
        if(curDt>(this.prevTime+300)){
            this.prevTime=curDt
            return true
        }

        return false
    }

    /**
     * This function is custom function to handle the events from the component.
     * this will ensure the component not to trigger the component default key handling.
     */
    onRight() {
        if(!this.canProcessKey()) return true
        if (!this.isTransition && this.items.length >= 0 && this.selected.itemIndex < this.data.item.rowList.videosCount - 1) {
            this.isTransition = true;
            this.appendItemsToRight(this.index)
            setTimeout(() => {
                this.selectNext()
            }, 16)
            
            // Log carousel impression for mid carousel rows
            const { appConfig } = AppData as AppSetup;
            const isCarouselRow = !this.disableVideoPreview && appConfig?.enableMidCarousel && this.data.item.rowList.row_type === 'carousel'
            if (isCarouselRow) {
                Logger.processUserAction('CarouselImpression');
            }
        }
        return true
    }

    /**
     * This function is custom function to handle the events from the component.
     * this will ensure the component not to trigger the component default key handling.
     */
    onLeft() {
        if(!this.canProcessKey()) return true
        if (!this.isTransition && this.items.length > 0 && this.selected.itemIndex > 0) {
            this.isTransition = true
            this.appendItemsToLeft(this.index)
            setTimeout(() => {
                this.selectPrevious()
            }, 16)
            
            // Log carousel impression for mid carousel rows
            const { appConfig } = AppData as AppSetup;
            const isCarouselRow = !this.disableVideoPreview && appConfig?.enableMidCarousel && this.data.item.rowList.row_type === 'carousel'
            if (isCarouselRow) {
                Logger.processUserAction('CarouselImpression');
            }
            
            return true
        }
        return this.selectedIndex == 0 ? false : true
    }

    override _focus() {
        super._focus()
        this.mode = 'focused'
        // this.patch({
        //   w: this.w || this.style.w,
        //   h: this.Items.y + (this.data.item.rowList.row_item_height * 1.2)
        // });
    }
    override _unfocus() {
        super._unfocus()
        this.mode = 'unfocused'
        // this.patch({
        //   w: this.w || this.style.w,
        //   h: this.Items.y + (this.data.item.rowList.row_item_height)
        // });
    }

    override _handleEnter() {
        this.fireAncestors('$handleEnter')
    }

    $GridThumbClick(target) {
        Log.info('$GridThumbClick: ', target, this)
        if (this.data?.item?.rowList?.row_type === 'non-click') {
            Log.info('$GridThumbClick: blocked for non-click row')
            return
        }
        this.selectedIndex = target.itemIndex
        const focusInfo: FocusInfo = {focusRow:this.data.rowUIIndex, foucsItem:target.itemIndex}
        this.fireAncestors('$updateClickHandle',focusInfo)
    }
    
    override get announce() {
        return this._announce || (this._Title && this._Title.announce);
    }

}
